/**
 * @file index.tsx
 *
 * @fileoverview Renders and empty element. Normally insde of a box.
 */

import { ReactNode } from "react";
import AlignedCenter from "../../02-atoms/06-layout/01-alignment/01-align-center";
import styles from "./empty.module.scss";

export interface EmptyElementProps {
  /**
   * The content to display inside the box.
   */
  children: ReactNode;
  /**
   * The icon to display inside the box.
   */
  icon?: ReactNode;
  /**
   * The width of the icon to display.
   */
  iconWidth?: string;
  /**
   * Color for the icon.
   */
  iconColor?: string;
  /**
   * The height of the icon to display.
   */
  iconHeight?: string;
}

/**
 * An empty element can be used to show any kind of empty state. Eithe for
 * resumes / companies but also empty dashboard states or other empty states of any kind.
 */
export default function EmptyElement({
  children,
  icon,
  iconColor,
  iconWidth,
  iconHeight,
}: EmptyElementProps) {
  return (
    <div className={styles.emptyElementWrapper}>
      <AlignedCenter>
        <div
          className={styles.iconWrapper}
          style={{
            color: iconColor,
            width: iconWidth,
            height: iconHeight,
          }}
        >
          {icon}
        </div>
        {children}
      </AlignedCenter>
    </div>
  );
}
export { EmptyElement };
